module.exports = __webpack_public_path__ + "img/gwnu_gallery6.c8420e90.jpg";